import React, { useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';

import useGlobal from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import UsuarioForm from './upsert/components/UsuarioForm';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ResponseError from '../../shared/responses/ResponseError';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../shared/responses/ResponseResult';
import SucursalSelection from './upsert/components/SucursalSelection';
import UsuarioPermissionsCreate from './upsert/components/UsurioPermissionsCreate';

const UsuariosUpsert = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { dataRouting = {} } = props.location.state || {};

  const { id } = props.match.params;

  useEffect(() => {
    actions.setInitialData(!!dataRouting.id ? { ...dataRouting } : { id });

    if (!!dataRouting.nombre || !id) {
      return;
    }

    actions.getInfo(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    actions.change({
      data: state.info.data,
      isValid: !!state.info.data,
    });
  }, [state.info.data]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnReset = () => {
    actions.resetError({
      error: undefined,
    });
  };

  const handleOnAction = (action: string) => {
    if (action === 'cancel') {
      return;
    }

    actions.reset();

    props.history.replace('/app/usuarios');
  };

  const handleSubmit = async (action, info) => {
    const { data } = state;

    let body = {
      nombre: data.nombre,
      password: data.password,
      email: data.email,
    };

    if (!!data.sucursales) {
      body.sucursales = data.sucursales.map((item) => {
        return item.value;
      });
    }

    if (!data.id) {
      const { selected = {} } = data;

      const result = Object.entries(selected)
        .map(([key, value]) => {
          return !!value ? key : null;
        })
        .filter((a) => a);

      body.roles = [data.role];
      body.permisos = result;
    }

    actions.upsert(body, data.id);
  };

  const handleOnFormDataChange = (event) => {
    actions.change(event);
  };

  const handleOnClean = () => {
    actions.cleanInfo({});
  };

  const renderError = () => {
    const { error } = state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={handleOnReset}
        />
      </div>
    );
  };

  const renderResult = () => {
    const { data, result } = state;

    const title = !data.id ? 'Registro exitoso' : 'Actualización exitosa';

    return (
      <div className="result-container">
        <ResponseResult
          title={title}
          result={result}
          onAction={handleOnAction}
        />
      </div>
    );
  };

  const handleOnChange = (values) => {
    const newData = {
      ...state,
      data: {
        ...data,
        ...values,
      },
    };

    actions.change(newData);
  };

  const { data, isValid, error, result, busy, info } = state;
  const { busy: fetching } = info;
  const { isPermissionsValid = false } = data;

  const title = !data.id ? 'Nuevo Usuario' : 'Editar Usuario';

  if (fetching) {
    return <Loading />;
  }

  return (
    <>
      {!!error && renderError()}

      {!!result && renderResult()}

      <PageHeader
        text="Usuarios"
        to="/app/usuarios"
      />

      <h5>{title}</h5>

      <Row>
        <Col
          xs
          sm={8}
          md={5}
        >
          <UsuarioForm
            data={data}
            onChangeInfo={handleOnClean}
            onFormDataChange={handleOnFormDataChange}
          />
        </Col>
      </Row>

      <Row>
        <Col
          xs
          sm={8}
          md={5}
        >
          <SucursalSelection
            data={data?.sucursales ?? []}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      {!data.id && (
        <Row className="mt-3">
          <Col>
            <UsuarioPermissionsCreate />
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <PopConfirm
            text="Quieres cancelar el registro actual?"
            onAction={handleOnAction}
          >
            <Button
              type="button"
              variant="secondary"
              disabled={busy}
              className="mr-3"
            >
              Cancelar
            </Button>
          </PopConfirm>

          <LoadingButton
            type="button"
            disabled={!isValid || (!data.id && !isPermissionsValid)}
            loading={busy}
            onClick={handleSubmit}
          >
            {!!data.id ? (busy ? 'Guardando...' : 'Guardar') : ''}
            {!data.id ? (busy ? 'Registrando...' : 'Registrar') : ''}
          </LoadingButton>
        </Col>
      </Row>
    </>
  );
};

const mapState = (state) => {
  return {
    ...state.app.usuarios.upsert,
    info: state.app.usuarios.info,
  };
};

const mapActions = (actions) => {
  const { usuarios } = actions.app;

  return {
    ...usuarios.upsert,
    getInfo: usuarios.info.info,
    getPermissions: usuarios.info.permissions,
    cleanInfo: usuarios.info.change,
  };
};

export default UsuariosUpsert;
